import { Injectable } from '@angular/core';
import { RdxDevTerminologyType } from '@frontend-site/shared/data';
import { ProjectStore } from './project';
import { SessionRepository } from './session';

export enum DevEntityTypeKey {
    L1 = 'l1',
    REQUIREMENT = 'requirement',
    WORKSTREAM = 'workstream',
    FIX_PACKAGE = 'fixpackage'
}

@Injectable({ providedIn: 'root' })
export class DevEntityService {
    constructor(private projectStore: ProjectStore, private sessionStore: SessionRepository) {}

    getDevEntityTranslateKey(entityType: string, isPlural: boolean = false, useOriginalTerminology: boolean = false): string {
        const devTerminologyType = this.sessionStore.applicationConfig?.devTerminology;

        const keyPrefix = 'SystemSetup.Configuration.DevelopmentTerminology.DevelopmentEntityTypes.';
        const finalEntityType = this.resolveEntityType(entityType, useOriginalTerminology);
        const keySuffix = `${isPlural ? 'Plural' : ''}.${this.getCamelCaseWord(finalEntityType)}`;
        const devTerminology: string = devTerminologyType === RdxDevTerminologyType.waterfall ? 'waterfall' : 'safe';
        return keyPrefix + devTerminology + keySuffix;
    }

    private resolveEntityType(entityType: string, useOriginalTerminology: boolean): string {
        const projectDetails = this.projectStore.projectDetails;
        const lowerCaseEntityType = entityType.toLowerCase();

        if (lowerCaseEntityType === DevEntityTypeKey.L1) {
            return this.resolveL1EntityType();
        }
        if (lowerCaseEntityType === DevEntityTypeKey.REQUIREMENT && projectDetails?.isIncludesAccAnalysisProject()) {
            return DevEntityTypeKey.FIX_PACKAGE;
        }
        if (lowerCaseEntityType === DevEntityTypeKey.REQUIREMENT && projectDetails?.isS4Project() && !useOriginalTerminology) {
            return DevEntityTypeKey.WORKSTREAM;
        }
        return entityType;
    }

    private resolveL1EntityType(): DevEntityTypeKey {
        const projectDetails = this.projectStore.projectDetails;

        if (projectDetails?.isIcr3Project()) {
            return DevEntityTypeKey.FIX_PACKAGE;
        }
        if (projectDetails?.isS4Project() && !projectDetails.isUnifiedProject()) {
            return DevEntityTypeKey.WORKSTREAM;
        }
        return DevEntityTypeKey.REQUIREMENT;
    }

    private getCamelCaseWord(word: string): string {
        return word.charAt(0).toLowerCase() + word.slice(1);
    }

    getListHeaderTranslationString(): string {
        let listHeaderTranslationString = 'REQUIREMENTS_NEW_UI';
        const projectDetails = this.projectStore.projectDetails;
        if (projectDetails?.isSalesforceProject()) {
            listHeaderTranslationString = 'salesforce.DEVELOPMENT';
        } else if (projectDetails?.isIncludesAccAnalysisProject()) {
            listHeaderTranslationString = 'FIX_PACKAGES';
        } else if (projectDetails?.isS4Project()) {
            listHeaderTranslationString = 'WORKSTREAMS';
        } else if (projectDetails?.rdxEnabled) {
            listHeaderTranslationString = 'DEVELOPMENT';
        }
        return listHeaderTranslationString;
    }
}
